module.exports = __webpack_public_path__ + "static/noteboook-tracking-creative-6b16ba0dd991bfdb0cb3947bfda58b6b.png";